import { useEffect, useState } from "react";
import {
    listarMetas,
    crearMeta,
    actualizarMeta,
    registrarAporteMeta,
    listarAportesMeta,
} from "../api/metaApi";

function normalizarMeta(row) {
    return {
        ...row,
        idMeta: row.idMeta ?? row.id_meta,
        montoObjetivo: Number(row.montoObjetivo ?? row.monto_objetivo ?? 0),
        montoActual: Number(row.montoActual ?? row.monto_actual ?? 0),
        fechaObjetivo: row.fechaObjetivo ?? row.fecha_objetivo ?? "",
    };
}

function normalizarAporte(row) {
    return {
        ...row,
        idMetaAporte: row.idMetaAporte ?? row.id_meta_aporte,
        idMeta: row.idMeta ?? row.id_meta,
        fechaAporte: row.fechaAporte ?? row.fecha_aporte,
        fechaCrea: row.fechaCrea ?? row.fecha_crea,
        monto: Number(row.monto ?? 0),
    };
}

export default function useMetas() {
    const [metas, setMetas] = useState([]);
    const [loading, setLoading] = useState(false);

    const [aportes, setAportes] = useState([]);
    const [loadingAportes, setLoadingAportes] = useState(false);

    const cargar = async () => {
        setLoading(true);
        try {
            const data = await listarMetas();
            setMetas(Array.isArray(data) ? data.map(normalizarMeta) : []);
        } catch (error) {
            console.error("Error cargando metas:", error);
            setMetas([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargar();
    }, []);

    const guardar = async (payload, idMeta) => {
        if (idMeta) {
            await actualizarMeta(idMeta, payload);
        } else {
            await crearMeta(payload);
        }
        await cargar();
    };

    const aportar = async (idMeta, payload) => {
        await registrarAporteMeta(idMeta, payload);
        await cargar();
    };

    const cargarAportes = async (idMeta) => {
        setLoadingAportes(true);
        try {
            const data = await listarAportesMeta(idMeta);
            setAportes(Array.isArray(data) ? data.map(normalizarAporte) : []);
        } catch (error) {
            console.error("Error cargando aportes:", error);
            setAportes([]);
        } finally {
            setLoadingAportes(false);
        }
    };

    return {
        metas,
        loading,
        guardar,
        aportar,
        recargar: cargar,
        aportes,
        loadingAportes,
        cargarAportes,
    };
}